import styles from "./OnboardingStyles.module.css"
import { useState } from 'react';
import PrimaryButton from "../Button/PrimaryButton/PrimaryButton";
import { StepFormProps } from "../../types/onboarding.types";
import SecondaryButton from "../Button/SecondaryButton/SecondaryButton";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useTranslation } from "react-i18next";
import { useOrderContext } from "../../context/OrderContext";
import { getOnboardingDietOptions } from "./onboardingOptions";
/**
* Onboarding step.
*
* @param props StepFormProps
* @param {(step: number) => void} props.setStep - Step change handler
* @param {number} props.currentStep - Current step
* @param {OnboardingFormData} props.formData - Onboarding data
* @param {React.Dispatch<React.SetStateAction<OnboardingFormData>>} props.setFormData - Onboarding data change handler
* @param {() => void} props.clearData - Clear data handler
* @returns TSX.Element
*/
const Step8Form = ({currentStep, setStep, formData, setFormData}:StepFormProps) => {
    const { t } = useTranslation(); // Translation
    const windowSize = useWindowSize(); // Window size
    const [chosenOptions, setChosenOptions] = useState<string[] >(formData.specialRequests ? formData.specialRequests: [""]) // Current chosen options
    const [extra, setExtra] = useState<string>(formData.note ? formData.note : "") // Current extra note
    const { handleOrder} = useOrderContext();
    // Diet options
    const optionList = getOnboardingDietOptions(t);
    // Handle choices selection
    const handleChoice = (choice: string) => {
        if (chosenOptions) { 
            setChosenOptions(prev => prev ? [...prev, choice] : [choice]);
        }
        // Handle deselect
        if(chosenOptions.includes(choice)){
            setChosenOptions(chosenOptions.filter(item => item !== choice));
        }
    };
    // Submit logic
    const handleAction = () => {
        const options = [...chosenOptions];
        if(extra !== ""){
            handleOrder("note", extra)
        }
        setFormData((prev: typeof formData)=>({...prev,specialRequests: options, note: extra}))
        setStep(currentStep+1)
    }
    // Handle part skip
    const handleSkip = ()=>{
        setChosenOptions([])
        setStep(currentStep+1)
    }

    return(
        <>
        <div className={styles.OnboardingContent}>
            <div className={styles.Container}>
                <div className={styles.SecondaryTitle}>
                    <p>{t("onboarding.steps.8.title")}</p>
                </div>
                <div className={styles.ActionGroupNote}>
                    <div className={styles.ChoiceButtons}>
                        {optionList.map(option => (
                            <SecondaryButton onClick={()=>handleChoice(option.slug)} text={option.text} key={option.slug} className={`${chosenOptions.includes(option.slug) ? `${styles.ChosenOption}` : undefined}  ${styles.ChoiceButtonRound}`} showChevron={false} colorVariant="primary"/>
                        ))}
                    </div>
                    <div className={styles.AdditionalNote}>
                        <textarea value={extra} onChange={(e)=>setExtra(e.target.value)} placeholder={t("onboarding.steps.8.buttons.note")}></textarea>
                    </div>
                </div>
                <div  className={styles.ContinueButton}>
                    
                    {windowSize > 900 && <SecondaryButton className={styles.ContinueChoice} text={t("onboarding.steps.8.dismiss")} colorVariant="neutral" onClick={()=>handleSkip()} showChevron={false}/>}
                    <PrimaryButton onClick={()=>handleAction()} text={t("buttons.proceed")}/>
                </div>
            </div>
        </div>
        </>
    )
};

export default Step8Form;
